// extracted by mini-css-extract-plugin
export default {"RenderTeam":"styles_RenderTeam__6cEJ7","photoContainer":"styles_photoContainer__P40R6","contactInfo":"styles_contactInfo__8ov32","opaque":"styles_opaque__yqH5X"};